/**
 * API helpers for the server-side Xero OAuth flow.
 * These call our backend endpoints, NOT Xero directly.
 */
import axios from "axios";
import { API } from "./client";

/** Check the user's server-side Xero connection state. */
export async function getXeroStatus() {
  const res = await axios.get(`${API}/xero/status`);
  return res.data; // { connected: bool, needs_reauth: bool }
}

/** URL to navigate the browser to in order to start the Xero OAuth flow. */
export function getXeroConnectUrl() {
  return `${API}/xero/connect`;
}

/** Remove the server-side Xero token for the current user. */
export async function disconnectXero() {
  const res = await axios.delete(`${API}/xero/disconnect`);
  return res.data;
}
